// Libraries
import { nest, select, selectAll } from 'd3'

// Data
import data from '../../data/data.json';
const miniResultsData = data['HD21_mini-results'];

const colors = {
  red: '#d64946',
  blue: '#21789B',
  backgroudNavy: '#000016',
  yellow: '#be9304',
  gray: '#686868',
  white: '#eeeeee',
  lightgray: '#A1A1A1',
  pink: "#D6468B",
  brown: "#D69146"
};

/** Mini results graphics */
const miniResultsDataNested = nest()
  .key(d => d.party)
  .entries(miniResultsData);
// miniResultsDataNested.reverse();

const resultsTable = selectAll('.hd21_results')
  .classed('mini-results', true)
  .selectAll('div.mini-results__table')
  .data(miniResultsDataNested)
  .join('div')
  .attr('class', d => `mini-results__table mini-results__table__${d.key}`)

resultsTable
  .append('div')
  .classed('party-name', true)
  .text(d => d.key);

resultsTable
  .append('div')
  .classed('table-headers', true)
  .selectAll('div.table-header')
  .data(['candidates', 'votes'])
  .join('div')
  .attr('class', 'table-header table-header__text')
  .text(d => d);

const tableRow = resultsTable
  .selectAll('div.table-row')
  .data(d => d.values)
  .join('div')
  .classed('table-row', true)
  .attr('id', d => d.candidate_slug)
  .text(d => d.party === 'Republican'
    ? '' : 'No candidates')

tableRow
  .append('div')
  .classed('candidate__cell candidate__party', true)
  .append('span')
  .attr(
    'class',
    d =>
      d.party === 'Republican'
        ? 'circle-pill pill--rep'
        : 'circle-pill',
    true
  )
  .style('background-color', d => colors[d.color])
  .text(d => (d.party === 'Republican' ? 'R' : ''));
tableRow
  .append('div')
  .classed('candidate__cell candidate__name', true)
  .each(function() {
    const data = select(this).data()[0];
    const name =
      data.is_winner === 'Yes' ? `✓ ${data.candidate}` : data.candidate;

    select(this)
      .append('span')
      .classed('t-weight-bold', true)
      .text(name);

    if (data.is_incumbent === 'Yes') {
      select(this)
        .append('span')
        .attr('class', 'pill pill--basic')
        .attr('title', 'Currently holds this seat')
        .text('Incumbent');
    }
  });
tableRow
  .append('div')
  .classed('candidate__cell candidate__vote', true)
  .text(d => d.votes);

// tableRow
//   .append('div')
//   .classed('candidate__cell candidate__pct', true)
//   .text(d => d.pct);

const tableRowExtra = selectAll('.hd21_results')
  .select('.mini-results__table:first-of-type')
  .append('div')
  .attr('class', 'table-row table-row__extra');
tableRowExtra
  .append('div')
  .classed('table-header__text', true)
  .text('total');
tableRowExtra
  .append('div')
  .classed('candidate__vote', true)
  .text('33,686');

const source = selectAll('.hd21_results')
  .append('div')
  .attr('class', 'mini-results__source')
  .text('Source: Associated Press')